import React from "react";
import { Link, useNavigate, useOutletContext, useParams } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import RoomChip from "../common/RoomChip";
import RoomDetailBody from "./RoomDetailBody";

/**
 * The /rooms/:roomId route — a deep link. Day-to-day the detail opens in a
 * modal from the Rooms grid; both render RoomDetailBody.
 */
export default function RoomDetail() {
  const { userId, roomId } = useParams();
  const { deviceIndex } = useOutletContext();
  const navigate = useNavigate();
  const basePath = `/admin/dash/users/${userId}`;

  // The room's own colours come from any device populated with it; the body
  // fetches the authoritative room with its device page.
  const room =
    (deviceIndex?.all || []).find((d) => String(d.roomId?._id) === String(roomId))?.roomId ??
    null;

  return (
    <div>
      <Link
        to={`${basePath}/rooms`}
        className="mb-4 inline-flex items-center gap-2 text-sm font-medium text-slate-600 hover:text-slate-900"
      >
        <FiArrowLeft size={16} /> Rooms
      </Link>

      <div className="mb-5 flex items-center gap-3">
        <h2 className="text-xl font-bold text-slate-900">{room?.name || "Room"}</h2>
        {room && <RoomChip room={room} size="md" />}
      </div>

      <RoomDetailBody
        userId={userId}
        roomId={roomId}
        onOpenDevice={(d) => navigate(`${basePath}/devices/${d._id}`)}
      />
    </div>
  );
}
